import React, {
  forwardRef,
  useImperativeHandle,
  useRef,
} from 'react';
import { FormTemplate, FormTemplateSection } from 'data/template/template.types';
import * as types from 'data/natConfiguration/natConfiguration.types';
import Form, {
  FieldUpdateHandlerParam,
} from 'shared/form';
import { FormLayout } from 'components/FormLayout';

type Props = {
  template: FormTemplate,
  data: Partial<types.NatConfiguration>
  i18nKeyPrefix?: string
  isEditing?: boolean,
  section: string
  onFieldUpdate?: (param: FieldUpdateHandlerParam, formSection?: 'main') => void
}

export type Ref = {
  isValid: (forceValidation: boolean, forceTouched: boolean) => boolean
  getValues: () => types.NatConfiguration
}

export const COLLECTION_FUNCTION_GROUP_I18N_KEY = 'natConfiguration.form';

const NatConfigurationForm = forwardRef<Ref, Props>(({
  template,
  data,
  i18nKeyPrefix = COLLECTION_FUNCTION_GROUP_I18N_KEY,
  section,
  onFieldUpdate = () => null,
}: Props, ref) => {
  const sectionRef = useRef<Form>(null);

  const isValid = (forceValidation = false, forceTouched = true) => {
    const isSectionValid = sectionRef.current?.isValid(forceValidation, forceTouched) ?? true;
    return isSectionValid;
  };

  const getValues = () => {
    const formValues: types.NatConfiguration = {
      ...sectionRef.current?.getValues(),
    };

    return formValues;
  };

  useImperativeHandle(ref, () => ({
    isValid,
    getValues,
  }));

  const onMainFieldUpdate = (param: FieldUpdateHandlerParam) => onFieldUpdate(param, 'main');

  return (
    <div className="utimaco-packet-switch-form" data-testid="natConfigurationForm" id="natConfigurationForm">
      <div data-testid={`natConfigurationForm${section}`}>
        <FormLayout>
          <Form
            ref={sectionRef}
            name={template.formId ?? template.key}
            defaults={data}
            fields={(template[section] as FormTemplateSection)?.fields}
            layout={(template[section] as FormTemplateSection)?.metadata?.layout?.rows}
            i18nKeyPrefix={i18nKeyPrefix}
            fieldUpdateHandler={onMainFieldUpdate}
          />
        </FormLayout>
      </div>
    </div>
  );
});

export default NatConfigurationForm;
